export const name = "n1aahm7x";
export const guideInfo = "g10cxxz4";
export const countryFlag = "c1j9ssi5";
export const skills = "sq58kaz";
export const location = "ly8zgi7";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");